import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { telHref } from "../lib/business";

const DISTRICTS = [
    "Melikgazi", "Kocasinan", "Talas", "İncesu", "Hacılar",
    "Develi", "Yahyalı", "Bünyan", "Pınarbaşı", "Tomarza",
    "Sarıoğlan", "Akkışla", "Felahiye", "Özvatan", "Sarız", "Yeşilhisar",
];

const NEIGHBORHOODS = [
    "Anbar", "Argıncık", "Hisarcık", "Erkilet", "Mimarsinan",
    "Esenyurt", "Beyazşehir", "Kayabağ", "Gesi", "Yıldızevler",
];

export const ServiceAreas = () => {
    return (
        <section
            id="bolgeler"
            data-testid="service-areas-section"
            className="relative py-20 sm:py-28 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-10">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0055FF]">
                        Hizmet Bölgeleri
                    </div>
                    <h2 className="mt-3 font-black tracking-tighter text-slate-900 text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        Kayseri'nin her noktasına <span className="text-[#0055FF]">tesisatçı</span>.
                    </h2>
                    <p className="mt-4 text-slate-600 text-base sm:text-lg">
                        Aşağıdaki ilçe ve mahallelerde 7/24 su tesisatçısı olarak hizmet veriyoruz. Bölgenizi
                        görmeseniz bile arayın — büyük ihtimalle yine geliriz.
                    </p>
                </div>

                <div className="mb-4 text-xs font-bold uppercase tracking-widest text-slate-500">
                    İlçeler
                </div>
                <div className="flex flex-wrap gap-2">
                    {DISTRICTS.map((d, i) => (
                        <motion.a
                            key={d}
                            href={telHref}
                            data-testid={`area-district-${i}`}
                            initial={{ opacity: 0, y: 8 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.3, delay: i * 0.02 }}
                            className="group inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white hover:bg-[#0055FF] hover:border-[#0055FF] hover:text-white px-4 py-2 text-sm font-semibold text-slate-800 transition-all"
                        >
                            <MapPin className="w-3.5 h-3.5 group-hover:scale-110 transition-transform" strokeWidth={2.5} />
                            {d} Tesisatçı
                        </motion.a>
                    ))}
                </div>

                <div className="mt-10 mb-4 text-xs font-bold uppercase tracking-widest text-slate-500">
                    Popüler Mahalleler
                </div>
                <div className="flex flex-wrap gap-2">
                    {NEIGHBORHOODS.map((n, i) => (
                        <span
                            key={n}
                            data-testid={`area-neighborhood-${i}`}
                            className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700"
                        >
                            <MapPin className="w-3 h-3 text-[#0055FF]" strokeWidth={2.5} />
                            {n}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceAreas;
